var map = {
	"./de/video-btn.png": "p+P0",
	"./en/video-btn.png": "DCid",
	"./es/video-btn.png": "POaK",
	"./fr/video-btn.png": "OO54",
	"./ja/video-btn.png": "nkuA",
	"./ko/video-btn.png": "kmkd",
	"./pt/video-btn.png": "k3TJ",
	"./ru/video-btn.png": "qAJS",
	"./tc/video-btn.png": "S2NA",
	"./th/video-btn.png": "EQoF"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "D4Nl";